import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import intlC from '../../constants/intl';
import AlertComp from './AlertComp'
import * as alertActions from '../../actions/alert';
import {bindActionCreators} from 'redux';
import C from  '../../constants/alert';

class Alert extends React.Component {

    render() {
        const alertIcon = this.props.alertData.alertIcon;
        const alertTitle = this.props.alertData.alertTitle;
        const alertText = this.props.alertData.alertText;
        const alertStyle = this.props.alertData.alertStyle;
        const displayTime = this.props.alertData.displayTime;
        const closeButton = this.props.alertData.closeButton;
        const alertActive = this.props.alertActive;

        return (
            <AlertComp alertIcon={alertIcon} alertTitle={alertTitle} alertText={alertText} alertStyle={alertStyle} displayTime={displayTime} closeButton={closeButton} alertActive={alertActive} actions={this.props.actions} />
        )
    }
}

Alert.propTypes = {
    intlObject: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    alertData: PropTypes.object.isRequired,
    alertActive: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
    return {
        intlObject: state.intl.get(intlC.INTL_OBJECT),
        alertData: state.alert.getIn([C.ALERT_PROPS]),
        alertActive: state.alert.getIn([C.ALERT_ACTIVE])
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(alertActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Alert);



// WEBPACK FOOTER //
// ./components/Alert/index.js